import { ApiError } from "../api/client";

/**
 * A human-readable message for any error a screen might catch. Special-cases the 403 shape the
 * admin routes use ("you are not an administrator of this deployment") since several screens can
 * hit it if the caller's admin status is revoked mid-session, and it deserves clearer framing
 * than a generic error banner.
 */
export function formatError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.isForbidden) {
      return "You are signed in but not an administrator of this deployment.";
    }
    return error.detail || error.message;
  }
  return error instanceof Error ? error.message : String(error);
}
